import { LargePart, Section, SmallPart } from 'components/Styled';
import { useGlobalState } from 'contexts/GlobalState';

const imageODS = [
	"educacaoqualidade",
	"igualdadegenero",
	'reducaodesigualdades',
	'mudancaglobaldoclima',
];

export default function SectionODS() {
  const [websiteText] = useGlobalState('websiteText')
  const [selectedLanguage] = useGlobalState('selectedLanguage')

  return (
    <Section className="py-20 bg-white text-black items-center">
      <SmallPart style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between'
				}}>
        <div className="pl-5 pr-14">
          <h2 className="mb-10 text-3xl font-semibold">
            {websiteText.section_titulo?.[selectedLanguage] || 'Objetivos de Desenvolvimento Sustentável (ODS)'}
          </h2>
        </div>
      </SmallPart>
      <LargePart className="gap-6 px-5 mt-10 md:mt-0">
        <div className="flex flex-row flex-wrap justify-center space-y-12">
          <div></div>
          {imageODS.map((image) => (
            <div key={image}>
              <img
                className='object-cover h-auto mr-10 md:w-40 w-36'
                src={`/assets/ods-${image}.png`}
                alt=''
              />
            </div>
          ))}
        </div>
      </LargePart>
    </Section>
  )
}
